/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { ConcernsIssueSummaryDto } from '../concernsIssueSummaryDto.schema';

export const IReadOnlyListOfConcernsIssueSummaryDto = zod.array(zod.lazy(() => ConcernsIssueSummaryDto));

export type IReadOnlyListOfConcernsIssueSummaryDto = zod.input<typeof IReadOnlyListOfConcernsIssueSummaryDto>;
export type IReadOnlyListOfConcernsIssueSummaryDtoOutput = zod.output<typeof IReadOnlyListOfConcernsIssueSummaryDto>;
